import React, { Component } from 'react';
import Nprogress from 'nprogress';
import ReactPlaceholder from 'react-placeholder';
import 'nprogress/nprogress.css';

import 'react-placeholder/lib/reactPlaceholder.css';
import CircularProgress from 'components/CircularProgress';

let isMounted = true;

/**
 * Set isMounted
 * @param {boolean} value
 */
const setIsMounted = (value = true) => {
  isMounted = value;
  return isMounted;
};

/**
 * Get isMounted
 */
const getIsMounted = () => isMounted;

export default function asyncComponent(importComponent) {
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null
      };
      setIsMounted(true);
    }

    UNSAFE_componentWillMount() {
      Nprogress.start();
    }

    async componentDidMount() {
      this.mounted = true;
      const { default: Component } = await importComponent();
      Nprogress.done();
      if (this.mounted) {
        this.setStateData({
          // eslint-disable-next-line react/jsx-props-no-spreading
          component: <Component {...this.props} />
        });
      }
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    /**
     * Set state properties
     * @param {object} state data cần setState
     * @param {function} callback thực thi hàm sau khi đã cập nhật state hoàn tất
     * @returns {void} gọi hàm this.setStateData để cập nhật state
     * @memberof asyncComponent
     */
    setStateData = (state, callback) => {
      if (!getIsMounted()) {
        return;
      }
      this.setState(state, callback);
    };

    render() {
      const Component = this.state.component || <CircularProgress />;
      return (
        <ReactPlaceholder ready={Component !== null} rows={7} type="text">
          {Component}
        </ReactPlaceholder>
      );
    }
  }

  return AsyncFunc;
}
